// extracted by mini-css-extract-plugin
export var logo = "_gz-2";
export var logoWrapper = "_gz-1";
export var strip = "_gz-0";